import React from 'react';

import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import BackButton from '../components/BackButton';
import { Heart, Users, Shield, TrendingUp, CheckCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const AidesSolidaires = () => {
  const aides = [
    {
      titre: "Garantie solidaire RCD SOLIDAIRE",
      description: "Responsabilité Civile Décennale solidaire et accessible",
      icon: Shield,
      color: "blue",
      image: "/templates/aide-solidaire-1.svg",
      avantages: [
        "Tarifs adaptés et transparents",
        "Prévention et accompagnement",
        "Mutualisation des risques"
      ],
      link: "/police-rcd-solidaire"
    },
    {
      titre: "Fonds de Garantie Solidaire",
      description: "Soutien financier pour les entreprises en difficulté",
      icon: Heart,
      color: "red",
      image: "/templates/aide-solidaire-2.svg",
      avantages: [
        "Aide en cas d'aléas financiers",
        "Continuité des chantiers garantie",
        "Décision collégiale et rapide"
      ]
    },
    {
      titre: "Accompagnement Coopératif",
      description: "Services d'accompagnement et de formation pour les membres",
      icon: Users,
      color: "green",
      image: "/templates/aide-solidaire-3.svg",
      avantages: [
        "Formation aux bonnes pratiques",
        "Conseil et expertise technique",
        "Réseau de professionnels"
      ]
    },
    {
      titre: "Dispositif de Prévention",
      description: "Actions préventives pour réduire les risques",
      icon: TrendingUp,
      color: "amber",
      image: "/templates/aide-solidaire-4.svg",
      avantages: [
        "Audits de chantiers",
        "Analyse des risques",
        "Plans d'action personnalisés"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <Navigation />      {/* Bouton Retour */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        <BackButton to="/" label="Retour à l'accueil" />
      </div>

      <div className="bg-gradient-to-r from-green-600 to-green-700 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">Aides Solidaires</h1>
          <p className="text-xl text-center text-green-100 max-w-3xl mx-auto">
            Des solutions coopératives pour soutenir les professionnels du BTP
          </p>
        </div>
      </div>

      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {aides.map((aide, index) => {
              const Icon = aide.icon;
              const colorClasses = {
                blue: 'bg-blue-100 text-blue-600',
                purple: 'bg-purple-100 text-purple-600',
                red: 'bg-red-100 text-red-600',
                green: 'bg-green-100 text-green-600',
                amber: 'bg-amber-100 text-amber-600'
              };
              
              return (
                <Card key={index} className="hover:shadow-2xl transition-all border-2 hover:border-green-300 overflow-hidden">
                  {/* Image de fond */}
                  {aide.image && (
                    <div className="relative h-48 overflow-hidden">
                      <img 
                        src={aide.image} 
                        alt={aide.titre}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                      <div className="absolute bottom-4 left-4 right-4">
                        <div className={`w-12 h-12 rounded-lg ${colorClasses[aide.color]} flex items-center justify-center mb-2`}>
                          <Icon className="h-6 w-6" />
                        </div>
                        <h3 className="text-xl font-bold text-white">{aide.titre}</h3>
                      </div>
                    </div>
                  )}
                  
                  <CardHeader className={aide.image ? 'pt-4' : ''}>
                    {!aide.image && (
                      <>
                        <div className={`w-14 h-14 rounded-lg ${colorClasses[aide.color]} flex items-center justify-center mb-4`}>
                          <Icon className="h-8 w-8" />
                        </div>
                        <CardTitle className="text-2xl">{aide.titre}</CardTitle>
                      </>
                    )}
                    <CardDescription className="text-base">{aide.description}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-2 mb-6">
                      {aide.avantages.map((avantage, i) => (
                        <li key={i} className="flex items-start">
                          <CheckCircle className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                          <span className="text-gray-700">{avantage}</span>
                        </li>
                      ))}
                    </ul>
                    <Link to={aide.link || "/register"}>
                      <Button className="w-full bg-green-600 hover:bg-green-700">
                        En savoir plus
                        <ArrowRight className="h-4 w-4 ml-2" />
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <Card className="mt-12 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200">
            <CardContent className="p-8 text-center">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Rejoignez notre coopérative</h2>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
                Ensemble, construisons un modèle solidaire pour l'avenir du BTP ultramarin
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/register">
                  <Button size="lg" className="bg-green-600 hover:bg-green-700">Devenir membre</Button>
                </Link>
                <Link to="/calculateur-batico">
                  <Button size="lg" variant="outline">Calculer mon tarif</Button>
                </Link>
              </div>
            </CardContent>
          </Card>

            </div>
      </div>

      <Footer />
    </div>
  );
};

export default AidesSolidaires;